export const LocaleConfig = { locales: {} };
